export default "__VITE_ASSET__BEP5YYYZ__"